export default import.meta.ROLLDOWN_FILE_URL_7bCSWf3vQpdgBz9NtfZ5_w